import script from "./signup.vue?vue&type=script&setup=true&lang=js"
export * from "./signup.vue?vue&type=script&setup=true&lang=js"

import "./signup.vue?vue&type=style&index=0&id=7e86cbaa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Acer\\Desktop\\mav\\surkhet\\patient-portal-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e86cbaa"]])

export default __exports__